package ui.campaign.detailv2.widgets

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp


@Composable
fun ThreeFieldText(
    label: String,
    messageCenter: Any,
    messageEnd: Any,
    weights: FloatArray = floatArrayOf(1F, 1F, 1F),
    showEndMsg: Boolean = true,
    labelStyle: TextStyle = LocalTextStyle.current,
    messageStyle: TextStyle = LocalTextStyle.current,
    modifier: Modifier = Modifier.fillMaxWidth()
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Text(
            text = label,
            style = labelStyle,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(weights.getOrNull(0) ?: 1F)
        )

        Text(
            text = messageCenter.toString(),
            textAlign = TextAlign.End,
            modifier = Modifier.weight(weights.getOrNull(1) ?: 1F)
                .align(Alignment.CenterVertically),
            style = messageStyle
        )
        if (showEndMsg) {
            Text(
                text = messageEnd.toString(),
                textAlign = TextAlign.End,
                modifier = Modifier.weight(weights.getOrNull(2) ?: 1F)
                    .align(Alignment.CenterVertically),
                style = messageStyle
            )
        }
    }
}